import React, { PureComponent } from 'react';

import styled, { css } from 'styled-components';

import { breakpoint } from 'theme';
import { getStyle } from '@shared/markup/functions';

export const icons = {
  arrow2: (
    <svg width="10" height="16" viewBox="0 0 10 16">
      <path
        fill="none"
        fillRule="nonzero"
        stroke="#17242A"
        strokeWidth="2"
        d="M1 15l7-7-7-7"
      />
    </svg>
  ),
  successCheck: (
    <svg fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M124 248c68.483 0 124-55.517 124-124S192.483 0 124 0 0 55.517 0 124s55.517 124 124 124Zm68.035-154.327L173.33 74.967l-70.241 70.24-27.842-26.471-18.227 19.171 46.535 44.245 88.48-88.48Z"
        fill="#007B8B"
      />
    </svg>
  ),
  warning: (
    <svg fill="none" viewBox="0 0 80 63">
      <path
        stroke="#17242A"
        strokeWidth={3}
        d="M37.89 6.123c.981-1.547 3.238-1.547 4.22 0L74.834 57.66c1.057 1.664-.14 3.84-2.11 3.84H7.277c-1.972 0-3.168-2.176-2.11-3.84L37.888 6.123Z"
      />
      <path
        fill="#17242A"
        fillRule="evenodd"
        d="m37.799 27 .14 4.346.752 13h3.618l.751-13L43.248 27h-5.45Zm.211 20.892c-.673.559-1.01 1.27-1.01 2.134 0 .864.337 1.576 1.01 2.135.673.56 1.511.839 2.514.839 1.002 0 1.832-.28 2.49-.839.657-.559.986-1.27.986-2.135 0-.864-.329-1.575-.987-2.135-.657-.559-1.487-.838-2.49-.838-1.002 0-1.84.28-2.513.839Z"
        clipRule="evenodd"
      />
    </svg>
  ),
  home: (
    <svg width="19" height="16" viewBox="0 0 19 16">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#5C656C"
          fillRule="nonzero"
          d="M7.75 15.5v-5.25h3.5v5.25h4.375v-7h2.625L9.5.625.75 8.5h2.625v7z"
        />
        <path d="M-1-2h21v21H-1z" />
      </g>
    </svg>
  ),
  help: (
    <svg width="19" height="19" viewBox="0 0 19 19">
      <g fill="none" fillRule="evenodd">
        <path d="M-1-1h21v21H-1z" />
        <path
          fill="#5C656C"
          fillRule="nonzero"
          d="M9.5.75C4.67.75.75 4.67.75 9.5s3.92 8.75 8.75 8.75 8.75-3.92 8.75-8.75S14.33.75 9.5.75zm.875 14.875h-1.75v-1.75h1.75v1.75zm1.811-6.781l-.787.805c-.63.639-1.024 1.164-1.024 2.476h-1.75v-.438c0-.962.394-1.837 1.024-2.476l1.085-1.102a1.71 1.71 0 0 0 .516-1.234c0-.963-.787-1.75-1.75-1.75s-1.75.787-1.75 1.75H6c0-1.934 1.566-3.5 3.5-3.5s3.5 1.566 3.5 3.5c0 .77-.315 1.47-.814 1.969z"
        />
      </g>
    </svg>
  ),
  onOff: (
    <svg viewBox="0 0 17 17">
      <g fill="none" fillRule="evenodd">
        <path d="M-2-2h21v21H-2z" />
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M9.375.625h-1.75v8.75h1.75V.625zm4.226 1.899L12.36 3.766A6.055 6.055 0 0 1 14.625 8.5 6.12 6.12 0 0 1 8.5 14.625 6.12 6.12 0 0 1 4.633 3.758L3.399 2.524A7.816 7.816 0 0 0 .625 8.5a7.876 7.876 0 0 0 15.75 0 7.816 7.816 0 0 0-2.774-5.976z"
        />
      </g>
    </svg>
  ),
  atlas: (
    <svg viewBox="30 30 110 110" width="72px" height="72px">
      <title>Group 4</title>
      <g id="Home" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-4">
          <path
            d="M87.1201,174.24 C39.0372,174.24 0,135.2028 0,87.12 C0,39.037 39.0372,0 87.1201,0 C135.203,0 174.24,39.037 174.24,87.12 C174.24,135.2028 135.203,174.24 87.1201,174.24 Z"
            id="Fill-1"
            fill="#007B8B"
          />
          <path
            d="M111.221,68.054 C114.704,68.054 117.572,69.3 119.165,72.413 C119.963,73.973 121.99,78.414 124.019,82.9524 L124.505,84.0421 C125.799,86.9452 127.053,89.7968 127.945,91.8671 L129.085,94.5094 L119.594,100.5185 L118.122,97.1591 L117.394,95.4949 C117.507,96.0976 117.588,96.5495 117.66,96.9819 C117.863,98.2021 117.968,99.1543 117.97,100.0367 C117.982,105.0368 117.611,112.2509 116.861,121.7098 C116.852,122.9546 116.5,124.1759 115.838,125.1998 L115.536,125.5966 C114.618,126.6301 113.312,127.1915 112.193,127.0922 L100.853,127.091 C100.601,127.0898 100.535,127.0874 100.403,127.0826 C99.0432,127.1915 97.7377,126.6301 96.8191,125.5966 L96.5175,125.1998 C95.8558,124.1759 95.5035,122.9546 95.4939,121.7098 C94.7439,112.2509 94.3738,105.0368 94.3857,100.0367 C94.3878,99.1543 94.4927,98.2021 94.6954,96.9819 C94.7672,96.5495 94.8486,96.0976 94.9618,95.4949 C94.4811,96.5924 94.1205,97.4155 93.8802,97.9642 C93.6316,98.5318 93.2586,99.3833 92.7613,100.5185 L89.6126,98.525 L83.2703,94.5094 L84.4099,91.8671 C84.5837,91.464 84.843,90.8684 85.158,90.1488 C85.4627,89.4526 85.8766,88.5163 86.3443,87.4628 L90.9838,97.5787 L97.5074,93.4395 L98.1238,95.7464 C97.8041,97.4338 97.5376,98.8993 97.5349,100.0448 C97.5232,104.9587 97.8928,112.1379 98.6438,121.5825 C98.6293,122.2281 98.8012,122.8595 99.13,123.3682 C99.4088,123.6819 99.7822,123.8425 100.162,123.8121 L104.603,123.8119 L104.603,100.855 L107.752,100.855 L107.751,123.8119 L112.193,123.8121 C112.573,123.8425 112.947,123.6819 113.225,123.3682 C113.554,122.8595 113.726,122.2281 113.712,121.5825 C114.462,112.1379 114.832,104.9587 114.82,100.0448 C114.815,97.5504 113.558,93.5387 113.225,89.0221 C113.104,87.3681 113.234,85.0539 113.618,82.0794 C113.62,81.7261 113.82,81.4196 114.103,81.3344 C114.387,81.2493 114.682,81.4072 114.82,81.7181 L120.988,95.7976 L125.073,93.2111 C123.853,90.3828 118.038,77.1837 116.386,73.956 C115.316,71.864 113.225,71.334 111.221,71.334 L101.134,71.334 C99.13,71.334 97.0398,71.864 95.9693,73.956 C95.3782,75.1109 94.2541,77.5427 92.9981,80.3192 L91.0514,76.3907 C91.7487,75.2746 92.3451,74.1 92.7932,73.203 L93.0695,72.651 C93.1117,72.567 93.152,72.488 93.1902,72.413 C94.7834,69.3 97.6509,68.054 101.134,68.054 L111.221,68.054 Z M98.252,81.3344 C98.5354,81.4196 98.7352,81.7261 98.7376,82.0794 C99.1209,85.0539 99.2517,87.3681 99.13,89.0221 C99.0649,89.9068 98.9643,90.7721 98.8446,91.6105 L95.4114,86.5661 C95.8833,85.4888 96.5911,83.8728 97.5349,81.7181 C97.6736,81.4072 97.9686,81.2493 98.252,81.3344 Z M106.173,46.733 C111.395,46.733 115.625,51.139 115.625,56.574 C115.625,62.008 111.395,66.414 106.178,66.414 C100.96,66.414 96.7301,62.008 96.7301,56.568 C96.7384,51.14 100.961,46.742 106.173,46.733 Z M106.178,50.013 C102.701,50.019 99.8848,52.953 99.8793,56.574 C99.8793,60.197 102.699,63.134 106.178,63.134 C109.656,63.134 112.476,60.197 112.476,56.574 C112.476,52.95 109.656,50.013 106.178,50.013 Z"
            id="Fill-2"
            fillOpacity="0.5"
            fill="#FFFFFF"
          />
          <path
            d="M79.8051,62.962 C83.9366,62.962 87.283,64.407 89.1198,67.976 C90.0807,69.842 92.4804,75.0619 94.9351,80.5132 L95.7243,82.2695 C97.3873,85.9781 99.0073,89.6393 100.152,92.2783 L101.269,94.8525 L90.6924,101.5096 L89.2099,98.1448 L86.0227,90.9112 L86.1133,129.0316 C86.1462,130.4894 85.7518,131.9294 84.9747,133.1249 L84.6751,133.5167 C83.6797,134.6299 82.2616,135.2362 81.029,135.1282 L66.8947,135.1274 C66.8569,135.1273 66.8215,135.1272 66.7884,135.1271 L66.5422,135.1258 C66.3631,135.1244 66.2716,135.1221 66.124,135.1183 C64.6441,135.2362 63.226,134.6299 62.2306,133.5167 L61.931,133.1249 C61.1539,131.9294 60.7595,130.4894 60.7915,129.0979 L60.8829,90.9114 L56.2132,101.5096 L45.6367,94.8525 L46.7535,92.2783 C47.8983,89.6393 49.5184,85.9781 51.1813,82.2695 L51.9706,80.5132 C54.4253,75.0619 56.825,69.842 57.7859,67.976 C59.6227,64.407 62.9691,62.962 67.1005,62.962 L79.8051,62.962 Z M79.8051,66.193 L67.1005,66.193 C64.5768,66.193 61.9444,66.857 60.5962,69.476 C58.5159,73.517 51.1921,90.0427 49.6558,93.5838 L54.8009,96.8222 L62.5679,79.1943 C62.7425,78.8049 63.1142,78.6073 63.4711,78.7139 C63.828,78.8204 64.0796,79.2042 64.0826,79.6466 L63.9645,129.1057 C63.9463,129.914 64.1628,130.7046 64.5768,131.3415 C64.928,131.7343 65.3983,131.9353 65.8767,131.8973 L71.8659,131.8964 L71.8664,100.9255 L75.0393,100.9255 L75.0382,131.8964 L81.029,131.8973 C81.5074,131.9353 81.9777,131.7343 82.3289,131.3415 C82.7429,130.7046 82.9594,129.914 82.9412,129.1057 L82.823,79.6466 C82.8261,79.2042 83.0777,78.8204 83.4346,78.7139 C83.7915,78.6073 84.1631,78.8049 84.3378,79.1943 L92.1048,96.8222 L97.2498,93.5838 C95.7136,90.0427 88.3898,73.517 86.3095,69.476 C84.9613,66.857 82.3289,66.193 79.8051,66.193 Z M73.473,37.089 C79.6066,37.089 84.5681,42.167 84.5681,48.423 C84.5681,54.679 79.6066,59.757 73.4781,59.757 C67.3496,59.757 62.3881,54.679 62.3881,48.418 C62.3978,42.169 67.3514,37.099 73.473,37.089 Z M73.4781,40.32 C69.1085,40.327 65.5679,43.951 65.561,48.423 C65.561,52.898 69.1056,56.526 73.4781,56.526 C77.8506,56.526 81.3952,52.898 81.3952,48.423 C81.3952,43.948 77.8506,40.32 73.4781,40.32 Z"
            id="Fill-3"
            fill="#FFFFFF"
          />
        </g>
      </g>
    </svg>
  ),
  body: (
    <svg viewBox="0 0 79 67">
      <g fill="none" fillRule="evenodd" stroke="#FFF" strokeWidth="3">
        <g strokeLinecap="round">
          <path d="M40.92 25.718L25.286 37.53a25.615 25.615 0 0 0-6.044 6.895c-2.373 3.96-3.665 6.282-3.749 8.34m4.252-9.178c-2.994 4.181-7.387 6.668-13.177 7.458m11.095-13.715c-4.906 1.542-8.104 1.345-9.593-.595m11.218-5.185c-.67-4.098-3.078-6.87-7.226-8.315" />
          <path d="M29.187 34.592c-3.032 1.276-5.583 1.906-7.647 1.895-3.097-.024-10.506 3.14-11.702 7.289" />
          <path d="M24.596 36.256c-3.232.043-5.005-1.604-5.318-4.938-.47-5.003 1.153-12.311 4.613-14.263" />
        </g>
        <g strokeLinecap="round">
          <path d="M39.007 25.718l15.38 11.813a25.492 25.492 0 0 1 5.948 6.895c2.334 3.96 3.605 6.282 3.688 8.34m-4.183-9.178c2.945 4.181 7.268 6.668 12.964 7.458M61.888 37.331c4.827 1.542 7.973 1.345 9.438-.595M60.29 31.551c.658-4.098 3.028-6.87 7.109-8.315" />
          <path d="M50.55 34.592c2.983 1.276 5.493 1.906 7.524 1.895 3.047-.024 10.336 3.14 11.512 7.289" />
          <path d="M55.067 36.256c3.18.043 4.925-1.604 5.232-4.938.462-5.003-1.134-12.311-4.538-14.263" />
        </g>
        <path d="M31.988 30.034c.935-11.262.818-19.994-3.215-23.705-4.032-3.71-12.999.346-19.379 12.185C3.014 30.359 1.84 39.73 2.016 48.636 2.192 57.536 4.313 65 10.222 65c3.403 0 5.24-3.655 8.14-7.57 2.14-2.88 5.226-5.805 8.03-8.002 6.606-5.176 4.663-8.128 5.596-19.392v-.002zm15.024 0c-.935-11.262-.818-19.994 3.215-23.705 4.032-3.71 12.999.346 19.379 12.185 6.38 11.843 7.554 21.217 7.378 30.12C76.808 57.537 74.687 65 68.778 65c-3.403 0-5.24-3.655-8.14-7.57-2.14-2.88-5.226-5.805-8.03-8.002-6.606-5.176-4.663-8.128-5.596-19.392v-.002z" />
        <path strokeLinecap="round" d="M39.5 2v24" />
      </g>
    </svg>
  ),
  motion: (
    <svg
      viewBox="0 0 300 271"
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        strokeLinejoin: 'round',
        strokeMiterlimit: 2,
      }}
    >
      <path
        d="M149.72 91.402c25.346 0 46.153-20.603 46.153-45.701S175.444 0 149.72 0c-25.347 0-46.153 20.603-46.153 45.701s20.806 45.701 46.153 45.701Zm0-83.91c21.185 0 38.586 17.231 38.586 38.209 0 20.977-17.401 38.209-38.586 38.209s-38.587-17.232-38.587-38.209c0-20.978 17.402-38.209 38.587-38.209ZM296.501 181.305c0-21.352-50.692-31.466-56.745-32.965l-1.135-7.866s-4.161-28.844-32.913-28.844H94.487c-28.751 0-32.912 28.844-32.912 28.844l-1.135 8.241C53.252 150.213.668 162.2.668 181.305c0 9.739 18.537 24.348 49.558 31.84l-3.027 14.61v.374c7.188 7.118 17.024 14.61 25.725 20.228v-1.123l16.267-90.278h9.457v104.512l.757.375c15.889 5.994 33.291 8.99 51.45 8.99 17.023 0 34.047-2.996 49.179-8.616l.757-.374v-41.58c7.187-.749 13.997-1.124 20.05-1.873l5.296 30.342.756.375c8.702-5.619 17.781-12.362 25.347-19.854l-2.648-16.108c31.777-7.492 46.909-18.729 46.909-31.84Zm-285.997 0c0-13.486 45.018-22.851 47.666-23.225l-7.188 45.326c-27.616-6.743-40.478-16.108-40.478-22.101Zm183.099 75.668c-15.132 4.495-27.616 6.368-41.614 6.368-15.888 0-30.264-2.247-45.396-7.117v-97.77c0-4.12-3.405-9.364-7.566-9.364h-9.458c-3.783 0-6.809 3.371-7.566 7.117l-14.375 78.665c-4.54-3.371-9.08-6.743-12.484-10.114l13.24-83.16c0-.75 3.783-22.476 25.725-22.476H205.33c21.185 0 25.346 20.228 25.725 22.476l10.214 62.557c-3.026.749-5.674 1.124-8.701 1.498-1.513.375-3.405.375-5.296.75l-8.701-50.196c-.757-3.746-3.783-7.117-7.566-7.117h-10.971c-4.161 0-6.053 5.244-6.053 9.364v51.32c-26.103 1.873-52.963 3.746-54.097 3.746l22.319-19.854-7.187-7.866-36.695 32.59 35.56 34.088 7.566-7.866-21.563-20.229c1.134 0 27.994-1.123 54.097-3.371l-.378 35.961Zm7.566-47.948v-52.444h9.457l8.702 50.571c-5.297.749-11.35 1.498-18.159 1.873Zm43.505 17.231c-3.783 3.746-7.945 7.118-12.484 10.489l-3.405-19.479c1.513-.375 3.026-.375 4.161-.749 3.405-.75 6.432-1.124 9.458-1.873l2.27 11.612Zm3.783-23.599-7.188-43.828c9.079 2.248 43.505 11.612 43.505 22.85 0 9.74-18.158 16.857-36.317 20.978Z"
        style={{
          fill: '#fff',
          fillRule: 'nonzero',
        }}
      />
    </svg>
  ),
  interactive: (
    <svg viewBox="0 0 62 55">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M1.32 11.762h59.36c.73 0 1.32.602 1.32 1.345v40.355c0 .743-.59 1.346-1.32 1.346H1.32c-.73 0-1.32-.603-1.32-1.346V13.107c0-.743.59-1.345 1.32-1.345zm23.744 14.797V40.01l12.285-6.726-12.285-6.726z"
        />
        <path
          stroke="#FFF"
          strokeLinecap="square"
          strokeWidth="2"
          d="M9.801 7.053h43.865m-38.588-5.38h32.02"
        />
      </g>
    </svg>
  ),
  ar: (
    <svg
      viewBox="0 0 255 292"
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        strokeLinejoin: 'round',
        strokeMiterlimit: 2,
      }}
    >
      <path
        d="M7.583 80.512c-1.063 0-2.127-.535-3.19-1.605-1.063-1.605-.532-3.745 1.063-4.815l119.089-69.01c1.595-1.07 3.721-.535 4.785 1.07 1.063 1.605.531 3.745-1.064 4.815L9.178 80.512H7.583ZM4.393 217.462c-1.063-1.605-.532-3.745 1.063-4.815L243.633 74.092c1.595-1.07 3.722-.535 4.785 1.07 1.064 1.605.532 3.745-1.063 4.815L9.178 218.532c-.532.534-1.063.534-1.595.534-1.063 0-2.127-.534-3.19-1.604Z"
        style={{
          fill: '#f3f3f3',
          fillOpacity: 0.7,
          fillRule: 'nonzero',
        }}
      />
      <path
        d="M245.76 80.512c-.532 0-1.063 0-1.595-.535l-119.089-69.01c-1.594-1.07-2.126-3.21-1.063-4.815 1.063-1.605 3.19-2.14 4.785-1.07l119.089 69.01c1.595 1.07 2.126 3.21 1.063 4.815-1.063 1.07-2.127 1.605-3.19 1.605ZM245.76 219.066c-.532 0-1.063 0-1.595-.534L5.988 80.512c-1.595-1.07-2.127-3.21-1.063-4.815 1.063-1.605 3.19-2.14 4.784-1.07l238.178 138.555c1.595 1.07 2.126 3.21 1.063 4.815-1.063.535-2.127 1.069-3.19 1.069ZM126.671 288.611c-.531 0-1.063 0-1.595-.535L5.988 218.532c-1.595-1.07-2.127-3.21-1.063-4.815 1.063-1.605 3.19-2.14 4.784-1.07l119.089 69.545c1.595 1.07 2.127 3.21 1.063 4.815-1.063 1.069-2.126 1.604-3.19 1.604Z"
        style={{
          fill: '#f3f3f3',
          fillOpacity: 0.7,
          fillRule: 'nonzero',
        }}
      />
      <path
        d="M126.671 288.611c-1.063 0-2.126-.535-3.189-1.604-1.064-1.605-.532-3.745 1.063-4.815l119.088-69.545c1.595-1.07 3.722-.535 4.785 1.07 1.064 1.605.532 3.745-1.063 4.815l-119.089 69.544c-.531 0-1.063.535-1.595.535Z"
        style={{
          fill: '#f3f3f3',
          fillOpacity: 0.7,
          fillRule: 'nonzero',
        }}
      />
      <path
        d="M7.583 219.066c-2.127 0-3.19-1.604-3.19-3.209V77.302c0-2.14 1.595-3.21 3.19-3.21 2.126 0 3.19 1.605 3.19 3.21v138.555c.531 1.605-1.064 3.209-3.19 3.209ZM126.671 288.076c-2.126 0-3.189-1.604-3.189-3.209V8.292c0-2.14 1.594-3.21 3.189-3.21 2.127 0 3.19 1.605 3.19 3.21v276.575c.532 1.605-1.063 3.209-3.19 3.209Z"
        style={{
          fill: '#f3f3f3',
          fillRule: 'nonzero',
        }}
      />
      <path
        d="M245.76 219.066c-2.127 0-3.19-1.604-3.19-3.209V77.302c0-2.14 1.595-3.21 3.19-3.21 2.127 0 3.19 1.605 3.19 3.21v138.555c0 1.605-1.595 3.209-3.19 3.209Z"
        style={{
          fill: '#f3f3f3',
          fillOpacity: 0.7,
          fillRule: 'nonzero',
        }}
      />
      <path
        d="m127.731 2.429.494.195a5.898 5.898 0 0 1 2.47 1.427l32.66 19.22c2.658 1.605 3.721 5.349 2.127 8.024 0 2.14-2.127 3.21-4.254 3.21-1.063 0-2.126 0-3.19-1.07l-25.521-14.553.003 33.277c0 3.209-2.659 5.884-5.849 5.884-3.189 0-5.848-2.675-5.848-5.884l-.002-33.886-26.58 15.162c-2.658 1.605-6.38.535-7.975-2.14-1.595-2.675-.531-6.419 2.127-8.024L122.95 2.942c1.276-.856 3.232-1.027 4.781-.513ZM166.545 123.843c1.595 2.675.531 6.42-2.127 8.025l-31.898 18.765v36.336c0 3.21-2.659 5.884-5.849 5.884-3.189 0-5.848-2.674-5.848-5.884l-.003-36.336-31.895-18.765c-2.659-1.605-3.722-5.35-2.127-8.025 1.595-2.674 5.317-3.744 7.975-2.139l31.898 18.188 31.899-18.188c2.658-1.605 6.38-.535 7.975 2.139ZM46.925 53.764c1.595 2.674.531 6.419-2.127 8.024L18.88 77.032l25.918 15.249c2.658 1.605 3.722 5.349 2.127 8.024-.532 2.14-2.659 3.21-4.785 3.21-1.064 0-2.127 0-3.19-1.07L13.43 87.432l.001 30.527c0 3.21-2.658 5.884-5.848 5.884s-5.848-2.674-5.848-5.884l-.006-39.232a5.696 5.696 0 0 1-.21-1.693 5.458 5.458 0 0 1 .747-2.942c.27-.452.6-.858.976-1.213a5.554 5.554 0 0 1 1.151-.927L38.95 51.624c2.658-1.605 6.38-.535 7.975 2.14ZM213.861 51.624l34.557 20.328a5.68 5.68 0 0 1 1.251 1.03c.338.329.632.701.876 1.11.273.459.468.948.591 1.454.303.706.472 1.481.472 2.291v40.122c0 3.21-2.658 5.884-5.848 5.884s-5.848-2.674-5.848-5.884l-.004-30.839-26.047 15.325c-1.063.535-2.126 1.07-2.658 1.07-2.127 0-4.253-1.07-5.316-3.21-1.595-2.675-.532-6.419 2.126-8.024l25.912-15.249-25.912-15.244c-2.658-1.605-3.721-5.35-2.126-8.024 1.595-2.675 5.316-3.745 7.974-2.14ZM245.76 169.85c3.19 0 5.848 2.675 5.848 5.885v40.122c0 2.728-1.921 5.071-4.457 5.711-.08.023-.166.043-.252.061l-.211.036a3.654 3.654 0 0 1-.359.049l-.132.01.001.002-.097.005L213.33 241c-.532.535-1.595 1.07-2.659 1.07-2.126 0-4.253-1.07-5.316-3.21-1.595-2.675-.532-6.42 2.127-8.024l26.178-15.407-25.647-15.086c-2.658-1.605-3.721-5.35-2.126-8.025 1.595-2.674 5.316-3.744 7.974-2.139L239.91 205.5l.002-29.765c0-3.021 2.355-5.568 5.291-5.858l.557-.027ZM7.583 169.85c3.19 0 5.848 2.675 5.848 5.885l-.002 29.453 25.521-15.009c2.658-1.605 6.38-.535 7.975 2.139 1.595 2.675.531 6.42-2.127 8.025l-25.919 15.245 25.919 15.248c2.658 1.604 3.722 5.349 2.127 8.024-.532 2.14-2.659 3.21-4.785 3.21-1.064 0-2.127 0-3.19-1.07L5.713 221.457c-1.428-.447-2.7-1.422-3.447-2.925a5.461 5.461 0 0 1-.747-2.941 5.709 5.709 0 0 1 .21-1.695l.006-38.161c0-3.21 2.658-5.885 5.848-5.885ZM126.671 291.286c-.949 0-1.899 0-2.849-.762a6.06 6.06 0 0 1-.869-.607l-34.56-20.029c-2.658-1.605-3.722-5.35-2.127-8.025 1.595-2.674 5.317-3.744 7.975-2.14l26.58 15.601.002-30.044c0-3.21 2.659-5.885 5.848-5.885 3.19 0 5.849 2.675 5.849 5.885l-.003 29.465 24.99-14.487c2.658-1.604 6.38-.535 7.975 2.14 1.594 2.675.531 6.42-2.127 8.025l-33.247 19.562c-.97.788-2.16 1.301-3.437 1.301Z"
        style={{
          fill: '#f3f3f3',
          fillRule: 'nonzero',
        }}
      />
    </svg>
  ),
  trace: (
    <svg viewBox="0 0 28 32">
      <g fill="#8B9194" fillRule="nonzero">
        <path d="M1.028 12c-.175 0-.357-.04-.518-.126-.488-.258-.656-.82-.371-1.262C1.437 8.631 5.382 4 14.002 4c3.734 0 7.008.898 9.728 2.669 2.239 1.453 3.493 3.098 4.091 3.89.321.423.197.991-.27 1.282-.466.284-1.108.178-1.429-.244-1.086-1.427-4.383-5.76-12.12-5.76-7.555 0-10.968 3.99-12.084 5.7-.19.304-.532.463-.89.463z" />
        <path d="M18.591 32a.987.987 0 0 1-.246-.028c-6.033-1.503-8.285-7.555-8.376-7.807l-.015-.056c-.049-.174-1.26-4.326.599-6.758.851-1.111 2.147-1.677 3.857-1.677 1.59 0 2.738.496 3.526 1.523.648.84.908 1.873 1.162 2.873.528 2.076.908 3.166 3.104 3.278.964.049 1.598-.517 1.957-1 .97-1.314 1.14-3.46.408-5.346-.943-2.446-4.28-7.052-10.164-7.052-2.513 0-4.822.81-6.673 2.334-1.534 1.265-2.752 3.047-3.336 4.878-1.084 3.411.338 8.772.352 8.82a.969.969 0 0 1-.704 1.189 1 1 0 0 1-1.218-.692c-.063-.245-1.583-5.962-.33-9.904C3.858 12.305 8.067 8 14.402 8c2.928 0 5.694 1 8.003 2.886 1.788 1.468 3.252 3.439 4.012 5.41.971 2.516.71 5.34-.662 7.184-.915 1.23-2.217 1.874-3.66 1.804-3.758-.19-4.434-2.824-4.927-4.746-.507-1.97-.83-2.921-2.766-2.921-1.063 0-1.809.293-2.274.901-.633.832-.682 2.132-.612 3.075.07.986.282 1.783.33 1.943.156.392 2.169 5.347 6.99 6.549a.97.97 0 0 1 .718 1.181.998.998 0 0 1-.964.734z" />
        <path d="M11.017 32a.956.956 0 0 1-.714-.326c-2.374-2.697-3.718-5.713-4.223-9.485v-.022c-.284-2.497.132-6.032 2.167-8.462C9.75 11.91 11.861 11 14.513 11c3.137 0 5.602 1.578 7.139 4.557 1.114 2.164 1.336 4.32 1.343 4.41.055.57-.34 1.074-.873 1.133-.533.06-1.017-.356-1.073-.919 0-.022-.194-1.875-1.142-3.683-1.191-2.275-3.005-3.43-5.4-3.43-2.071 0-3.691.674-4.806 2.008-1.606 1.919-1.918 4.875-1.696 6.832.443 3.334 1.627 5.987 3.718 8.358a1.076 1.076 0 0 1-.049 1.46.947.947 0 0 1-.657.274z" />
        <path d="M22.563 29c-2.256 0-4.174-.607-5.709-1.813-3.083-2.412-3.43-6.342-3.444-6.508-.046-.556.39-1.04.977-1.083.587-.044 1.091.368 1.136.924.008.058.316 3.272 2.693 5.121 1.406 1.091 3.287 1.524 5.603 1.272.58-.065 1.106.332 1.174.888.068.556-.354 1.055-.933 1.112a13.4 13.4 0 0 1-1.497.087zm1.783-26.79C23.466 1.654 20.344 0 14.478 0c-6.16 0-9.29 1.827-9.982 2.29-.045.029-.09.057-.127.094-.008.007-.015.007-.015.007A.99.99 0 0 0 4 3.142c0 .556.474 1.004 1.06 1.004.234 0 .444-.072.617-.188l-.007.007c.03-.021 2.73-1.95 8.808-1.95 6.077 0 8.777 1.936 8.807 1.95l-.007-.007.015-.014c.18.13.399.202.64.202.586 0 1.06-.448 1.06-1.004 0-.419-.263-.78-.647-.932z" />
      </g>
    </svg>
  ),
  trash: (
    <svg viewBox="0 0 26 31">
      <path
        fill="#8B9194"
        fillRule="nonzero"
        d="M2.6 27.563C2.6 29.453 4.16 31 6.067 31h13.866c1.907 0 3.467-1.546 3.467-3.437V7.75H2.6v19.813zM26 2.583h-6.5L17.324 0H8.676L6.5 2.583H0v2.584h26V2.583z"
      />
    </svg>
  ),
  xRays: (
    <svg
      viewBox="0 0 363 325"
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        strokeMiterlimit: 10,
      }}
    >
      <path
        d="M67.361 50h227.778c9.588 0 17.361 7.773 17.361 17.361v190.278c0 9.588-7.773 17.361-17.361 17.361H67.361C57.773 275 50 267.227 50 257.639V67.361C50 57.773 57.773 50 67.361 50Z"
        style={{
          fill: 'none',
          fillRule: 'nonzero',
          stroke: '#fff',
          strokeWidth: '9.25px',
        }}
      />
      <path
        d="m184.588 91.673-.001 121.227M128.923 148.369l113.747.001M139.688 174.718h92.227M120.833 120.704H250"
        style={{
          fill: 'none',
          fillRule: 'nonzero',
          stroke: '#fff',
          strokeWidth: '9.25px',
          strokeLinecap: 'round',
        }}
      />
      <path
        d="M185.417 216.15c-6.421 0-12.432-1.549-17.577-2.908-3.935-1.043-7.341-2.529-10.102-.585-.415 1.096-.576 2.576-.576 4.51 0 7.934 3.175 15.121 8.32 20.316 5.102 5.152 12.147 8.35 19.935 8.35 7.788 0 14.833-3.198 19.935-8.35 5.145-5.201 8.32-12.382 8.32-20.316 0-1.934-.161-3.414-1.173-5.39-2.164-1.059-5.57.422-9.505 1.465-5.145 1.359-11.156 2.908-17.577 2.908Z"
        style={{
          fill: 'none',
          fillRule: 'nonzero',
          stroke: '#fff',
          strokeWidth: '9.25px',
        }}
      />
    </svg>
  ),
  heart: (
    <svg width="42" height="37" viewBox="0 0 42 37">
      <path
        fill="#FFF"
        fillRule="evenodd"
        d="M35.644 1.895A12.05 12.05 0 0 0 29.759.39c-3.243 0-6.286 1.27-8.56 3.541a12.264 12.264 0 0 0-8.593-3.54c-2.04 0-4.08.534-5.885 1.503A12.195 12.195 0 0 0 .435 12.55c0 .401.033.836.067 1.236H6.152L8.226 5.77c.133-.501.601-.835 1.136-.835.535.033.937.434 1.037.935l2.106 14.432 2.441-9.655a1.115 1.115 0 0 1 1.104-.835c.501 0 .936.367 1.036.902l.937 4.877h8.359a.985.985 0 0 1 1.003 1.003.985.985 0 0 1-1.003 1.002h-9.128a1.08 1.08 0 0 1-1.07-.869l-.335-1.637-2.574 10.156a1.105 1.105 0 0 1-1.07.835h-.067c-.535-.033-.97-.434-1.037-.935L8.995 10.647 7.858 14.99c-.134.468-.569.835-1.07.835H.836c.033.134.1.3.134.435 1.973 8.92 18.892 19.61 19.627 20.077.167.1.368.167.569.167.2 0 .4-.067.568-.167.736-.468 17.655-11.158 19.594-19.977.401-1.203.602-2.472.602-3.742 0-4.51-2.408-8.585-6.286-10.723z"
      />
    </svg>
  ),
  videos: (
    <svg
      viewBox="0 0 359 325"
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        strokeMiterlimit: 10,
      }}
    >
      <path
        d="M67.587 50h225c10.355 0 18.75 8.395 18.75 18.75v187.5c0 10.355-8.395 18.75-18.75 18.75h-225c-10.355 0-18.75-8.395-18.75-18.75V68.75c0-10.355 8.395-18.75 18.75-18.75Z"
        style={{
          fill: 'none',
          fillRule: 'nonzero',
          stroke: '#fff',
          strokeWidth: '9.25px',
        }}
      />
      <path
        d="M55.603 87.569h248.969"
        style={{
          fill: 'none',
          fillRule: 'nonzero',
          stroke: '#fff',
          strokeWidth: '9.25px',
          strokeLinecap: 'square',
        }}
      />
      <path
        d="m91.288 87.569 37.706-37.109m13.035 37.109 37.706-37.109m13.035 37.109 37.706-37.109m13.035 37.109 37.706-37.109"
        style={{
          fill: 'none',
          fillRule: 'nonzero',
          stroke: '#fff',
          strokeWidth: '9.25px',
        }}
      />
      <path
        d="m237.819 178.412-90.206 54.192V124.221l90.206 54.191Z"
        style={{
          fill: 'none',
          fillRule: 'nonzero',
          stroke: '#fff',
          strokeWidth: '9.25px',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
    </svg>
  ),
  lectures: (
    <svg
      viewBox="0 0 359 375"
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        strokeMiterlimit: 10,
      }}
    >
      <path
        d="m202.74 263.531-129.927-1.607c-13.345 0-24.162-10.206-24.162-22.797V72.207c0-12.59 10.817-22.797 24.162-22.797h212.092c13.344 0 24.162 10.207 24.162 22.797v166.92c0 12.591-10.818 22.797-24.162 22.797l-12.72 1.607"
        style={{
          fill: 'none',
          fillRule: 'nonzero',
          stroke: '#fff',
          strokeWidth: '9.26px',
        }}
      />
      <circle
        cx={237.462}
        cy={194.086}
        r={52.083}
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '9.26px',
        }}
      />
      <path
        d="M75.425 104.387h207.263M75.425 156.47h89.87M75.425 208.554h83.912"
        style={{
          fill: 'none',
          fillRule: 'nonzero',
          stroke: '#fff',
          strokeWidth: '9.26px',
          strokeLinecap: 'round',
        }}
      />
      <path
        d="m270.093 235.62 13.666 91.568-46.297-21.044-46.296 21.044 13.985-92.765"
        style={{
          fill: 'none',
          fillRule: 'nonzero',
          stroke: '#fff',
          strokeWidth: '9.26px',
        }}
      />
    </svg>
  ),
  player: (
    <svg width="41" height="47" viewBox="0 0 41 47">
      <g fill="#FFF" fillRule="evenodd" transform="translate(.174 .217)">
        <ellipse cx="23.492" cy="3.388" rx="3.324" ry="3.29" />
        <path d="M36.962 35.804c1.836 0 3.323 1.472 3.323 3.289 0 1.817-1.487 3.29-3.323 3.29-1.836 0-3.324-1.473-3.324-3.29s1.489-3.29 3.324-3.29zM13.49 25.23L4.183 20.15a2.591 2.591 0 0 0-3.5 1.003 2.537 2.537 0 0 0 1.012 3.464l11.38 6.209a2.595 2.595 0 0 0 3.386-.817l1.99-2.95 3.486 4.585 5.457 13.086a2.578 2.578 0 0 0 2.384 1.578c.326 0 .66-.062.981-.193a2.542 2.542 0 0 0 1.4-3.33l-5.583-13.389a2.56 2.56 0 0 0-.324-.561l-3.327-4.375 1.972-11.507 8.605 3.948c.272.124.557.183.84.183.757 0 1.482-.427 1.82-1.153a1.975 1.975 0 0 0-.98-2.632L27.52 9.8l-2.13-.992a1.984 1.984 0 0 0-.602-.164l-8.622-2.776a2.015 2.015 0 0 0-.537-.198l-.198-.039-.156-.05v.02L8.018 4.17 3.284.432A2.016 2.016 0 0 0 .468.748a1.969 1.969 0 0 0 .317 2.787l5.117 4.038c.25.197.544.333.858.394l8.086 1.594c.11.022.217.028.324.032l-.359 13.68-1.321 1.957z" />
      </g>
    </svg>
  ),
  boneParts: (
    <svg
      viewBox="0 0 263 259"
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        strokeLinejoin: 'round',
        strokeMiterlimit: 2,
      }}
    >
      <path
        d="M221.693 46.402c-2.891 0-5.689.341-8.39.948a37.872 37.872 0 0 0 1.095-8.968C214.398 17.185 197.173 0 175.892 0c-21.254 0-38.471 17.185-38.471 38.382 0 10.692 4.393 20.363 11.477 27.319l-81.475 80.618a38.405 38.405 0 0 0-27.098-11.144c-21.266 0-38.494 17.193-38.494 38.385 0 21.2 17.228 38.375 38.494 38.375 2.887 0 5.692-.334 8.393-.944a38.436 38.436 0 0 0-1.094 8.961c0 21.2 17.228 38.381 38.486 38.381 21.262 0 38.502-17.181 38.502-38.381a38.16 38.16 0 0 0-10.439-26.217l81.534-80.692a38.341 38.341 0 0 0 25.974 10.112c21.259 0 38.483-17.19 38.483-38.389.026-21.178-17.217-38.367-38.471-38.367v.003ZM89.134 139.419c5.826-.426 35.823-2.154 58.376 6.748l-13.221 13.079c-17.455-7.77-40.687-8.609-57.177-7.929l12.022-11.898Zm-48.806 6.112c7.143 0 13.849 2.708 19.066 7.547-11.882 1.987-32.713 6.856-47.036 17.663 1.425-14.141 13.425-25.21 27.97-25.21Zm-27.829 31.777c18.664-16.753 56.086-20.289 56.661-20.334 25.017-1.976 46.431.285 61.121 6.246l-15.836 15.672c-49.263-16.516-89.879 7.895-96.169 11.987a27.851 27.851 0 0 1-5.777-13.571Zm33.952 23.572c-2.009.46-4.064.696-6.126.702a28.022 28.022 0 0 1-18.397-6.881c7.633-4.795 44.063-25.251 88.301-11.643l-3.365 3.337a10.334 10.334 0 0 0-2.872 5.402c-28.338-6.904-43.73 4.854-49.34 10.707a10.412 10.412 0 0 0-8.201-1.624Zm67.775 19.068c0 15.454-12.617 28.033-28.108 28.033-15.492 0-28.101-12.579-28.101-28.033 0-2.098.282-4.31.809-6.56.533-2.323.245-4.76-.816-6.896 4.438-4.824 18.627-16.623 46.412-9.25a10.235 10.235 0 0 0 2.193 3.578 27.904 27.904 0 0 1 7.611 19.128Zm37.262-77.718c-19.622-8.468-44.676-8.782-56.791-8.313l12.831-12.701c9.247-.533 36.935-1.232 57.648 7.474l-13.688 13.54Zm70.205-29.424a28.003 28.003 0 0 1-18.943-7.392c-4.094-3.741-10.414-3.614-14.353.289l-19.276 19.083c-18.791-8.598-43.062-9.349-56.113-8.99l43.181-42.733a10.306 10.306 0 0 0-.018-14.732 27.743 27.743 0 0 1-8.375-19.942c0-15.45 12.608-28.022 28.089-28.022 15.499 0 28.111 12.572 28.111 28.022a28.101 28.101 0 0 1-.805 6.564 10.339 10.339 0 0 0 2.707 9.686 10.411 10.411 0 0 0 9.676 2.834 28.164 28.164 0 0 1 6.144-.696c15.481 0 28.093 12.572 28.093 28.022-.01 15.436-12.623 28.007-28.118 28.007Z"
        style={{
          fill: '#fff',
          fillRule: 'nonzero',
        }}
      />
    </svg>
  ),
  pelvic: (
    <svg width="38" height="31" viewBox="0 0 38 31">
      <g fill="#FFF" fillRule="evenodd">
        <path d="M30.006 20.25c2.157-.135 1.716-.62 1.716-.62-1.408-1.33.836-2.129.836-2.129 4.664-1.195 4.103-3.528 3.915-4.918-.491-3.587-3.63-5.405-5.75-6.295-4.957-2.08-7.368.825-9.033 2.483-.46.457-1.407 1.063-2.333 1.108h-.404c-.924-.045-1.873-.651-2.332-1.108-1.666-1.66-4.075-4.563-9.033-2.483-2.12.89-5.258 2.708-5.75 6.295-.19 1.39-.747 3.722 3.916 4.918 0 0 2.244.798.836 2.129 0 0-.439.485 1.717.62 0 0 2.03 2.656 3.21 1.463.664-.67 1.232-1.153 3.521 1.064 0 0 1.628 1.285 3.476.309 0 0 1.451-.665-.837-1.372 0 0-6.702-1.2-5.762-6.207.747-3.989 4.928-1.101 6.291-.31.22.128.467.23.95.264.482-.034.73-.136.949-.263 1.364-.792 5.545-3.68 6.292.31.939 5.005-5.765 6.206-5.765 6.206-2.284.708-.834 1.372-.834 1.372 1.848.974 3.475-.309 3.475-.309 2.289-2.217 2.857-1.733 3.52-1.064 1.182 1.195 3.213-1.463 3.213-1.463z" />
        <path d="M19.263 15.47l-.107-.01-.106.01zM9.715 22.642l-1.451-1.108c-1.1-1.064-1.673-.31-1.673-.31-.924 2.04-2.463.931-2.463.931-.132-1.195-.437-1.373-.792-1.508-2.34-.877-2.331 2.082-2.331 2.082C-.623 24.637.96 25.92.96 25.92c1.453.843 1.013 4.167 1.013 4.167l3.914.09s-.636-3.288 0-4.077c.538-.668.96-1.627 1.496-1.907.43-.223 1.937-.088 1.937-.088 1.539-.708.395-1.462.395-1.462zM37.207 22.731s.012-2.96-2.332-2.082c-.353.134-.658.311-.79 1.508 0 0-1.54 1.108-2.463-.931 0 0-.572-.752-1.672.31l-1.453 1.107s-1.146.753.394 1.465c0 0 1.51-.137 1.94.088.533.277.958 1.237 1.496 1.906.634.79 0 4.077 0 4.077l3.914-.087s-.44-3.324 1.013-4.166c0-.004 1.584-1.29-.047-3.195zM16.844 6.554v.975c.087.798.922 1.02.922 1.02h2.684s.836-.222.925-1.02v-.975s2.243-1.774 1.671-2.216c0 0-.22-.561-2.551 1.33H17.723c-2.333-1.891-2.553-1.33-2.553-1.33-.572.442 1.674 2.216 1.674 2.216z" />
        <path d="M16.844 2.683v.975c.087.798.922 1.02.922 1.02h2.684s.836-.222.925-1.02v-.975S23.618.91 23.046.467c0 0-.22-.56-2.551 1.33H17.723C15.39-.093 15.17.467 15.17.467c-.572.443 1.674 2.216 1.674 2.216z" />
      </g>
    </svg>
  ),
  group: (
    <svg width="41" height="41" viewBox="0 0 41 41">
      <g fill="#FFF" fillRule="evenodd" transform="translate(.857 .857)">
        <ellipse cx="19.609" cy="3.446" rx="3.439" ry="3.446" />
        <path d="M20.912 7.66h-2.617a4.774 4.774 0 0 0-4.676 4.916v.735c0 .368.138.781.55.781h10.82c.413 0 .55-.413.55-.78v-.736a4.774 4.774 0 0 0-4.627-4.915zM4.943 22.383c.38 0 .688-.309.688-.69a14.21 14.21 0 0 1 5.318-11.12.644.644 0 0 0 .092-.964.687.687 0 0 0-.963-.092 15.636 15.636 0 0 0-5.823 12.177c0 .38.308.689.688.689zM24.394 35.778a14.457 14.457 0 0 1-9.032 0 .687.687 0 0 0-.87.46.736.736 0 0 0 .458.873c1.584.516 3.24.78 4.905.781a15.42 15.42 0 0 0 4.998-.827.69.69 0 0 0-.459-1.287zM27.53 10.61a14.3 14.3 0 0 1 6.015 11.631.689.689 0 1 0 1.376 0 15.725 15.725 0 0 0-6.602-12.773.732.732 0 0 0-.963.183.69.69 0 0 0 .175.96z" />
        <ellipse cx="5.992" cy="28.978" rx="3.439" ry="3.446" />
        <path d="M7.295 33.193l-.05-.002H4.679A4.774 4.774 0 0 0 .001 38.06l.001.049v.735c0 .368.138.781.55.781h10.82c.413 0 .55-.413.55-.78v-.736a4.774 4.774 0 0 0-4.627-4.915z" />
        <ellipse cx="33.226" cy="28.978" rx="3.439" ry="3.446" />
        <path d="M34.529 33.193l-.05-.002h-2.567a4.774 4.774 0 0 0-4.677 4.868l.001.049v.735c0 .368.138.781.55.781h10.82c.413 0 .55-.413.55-.78v-.736a4.774 4.774 0 0 0-4.627-4.915z" />
      </g>
    </svg>
  ),
  account: (
    <svg width="19" height="18" viewBox="0 0 19 18">
      <g fill="currentColor">
        <path d="M7.149 7.794c-2.179 0-3.951-1.748-3.951-3.897S4.97 0 7.148 0C9.328 0 11.1 1.748 11.1 3.897s-1.772 3.897-3.95 3.897zm0-6.625c-1.525 0-2.766 1.224-2.766 2.728 0 1.504 1.24 2.728 2.766 2.728 1.524 0 2.765-1.224 2.765-2.728 0-1.504-1.24-2.728-2.765-2.728zM17.61 18h-4.369c-.766 0-1.39-.603-1.39-1.345v-2.691c0-.742.624-1.345 1.39-1.345h4.37c.766 0 1.389.603 1.389 1.345v2.69c0 .743-.623 1.346-1.39 1.346zm-4.369-4.228c-.11 0-.198.086-.198.192v2.69c0 .107.089.193.198.193h4.37c.109 0 .198-.086.198-.192v-2.691c0-.106-.09-.192-.199-.192h-4.369z" />
        <path d="M16.714 13.732H13.95c-.327 0-.593-.26-.593-.582v-1.746c0-1.07.887-1.94 1.976-1.94s1.975.87 1.975 1.94v1.746c0 .321-.266.582-.593.582zm-2.172-1.164h1.58v-1.164c0-.428-.355-.776-.79-.776-.436 0-.79.348-.79.776v1.164zM9.984 16.515H.599c-.33 0-.599-.263-.599-.587v-2.742c0-2.052 1.702-3.722 3.794-3.722h6.988c.668 0 1.325.173 1.9.501.286.163.383.523.217.803-.166.282-.533.376-.82.213-.392-.223-.84-.342-1.297-.342H3.794c-1.431 0-2.596 1.143-2.596 2.547v2.154h8.786c.33 0 .599.263.599.588 0 .324-.269.587-.6.587z" />
      </g>
    </svg>
  ),
  xRay: (
    <svg viewBox="0 0 64 64">
      <path
        fill="#FFF"
        d="M59 0c2.761 0 5 2.239 5 5v54c0 2.761-2.239 5-5 5H5c-2.761 0-5-2.239-5-5V5c0-2.761 2.239-5 5-5h54zM40.438 50.433H23.575c-2.957 0-5.338 1.937-5.338 4.318 0 2.38 2.381 4.317 5.338 4.317 2.956 0 5.338-1.936 5.338-4.317 0-.21 0-.354-.053-.563h6.293c-.052.21-.052.353-.052.563 0 2.38 2.394 4.317 5.337 4.317 2.944 0 5.338-1.936 5.338-4.317 0-2.381-2.394-4.318-5.338-4.318zM33.944 40.23h-3.888c-.552 0-1 .448-1 1v4.45c0 .552.448 1 1 1h3.888c.552 0 1-.448 1-1v-4.45c0-.552-.448-1-1-1zm-1.996-35.31c-1.413 0-2.643 1.02-2.892 2.342H28.9c-10.858.654-18.433 4.67-18.433 9.746 0 .76.615 1.322 1.321 1.322.76 0 1.322-.615 1.322-1.322 0-2.943 6.096-6.54 15.895-7.156v5.142H28.9c-10.858.654-18.433 4.67-18.433 9.746 0 .759.615 1.322 1.321 1.322.76 0 1.322-.615 1.322-1.322 0-2.943 6.096-6.541 15.895-7.156v5.128H28.9c-10.858.654-18.433 4.67-18.433 9.747 0 .759.615 1.321 1.321 1.321.76 0 1.322-.615 1.322-1.321 0-2.944 6.096-6.541 15.895-7.156v5.128H28.9c-10.858.654-18.433 4.67-18.433 9.747 0 .758.615 1.321 1.321 1.321.76 0 1.322-.615 1.322-1.321 0-2.944 6.096-6.542 15.947-7.157.197 1.413 1.413 2.486 2.892 2.486 1.465 0 2.682-1.06 2.89-2.486 9.852.602 15.949 4.213 15.949 7.157 0 .758.614 1.321 1.32 1.321.76 0 1.322-.615 1.322-1.321 0-5.076-7.561-9.093-18.433-9.747h-.105V25.29c9.8.601 15.896 4.212 15.896 7.156 0 .759.614 1.321 1.32 1.321.76 0 1.322-.615 1.322-1.321 0-5.076-7.561-9.093-18.433-9.747h-.105V17.57c9.8.602 15.896 4.213 15.896 7.156 0 .759.614 1.321 1.32 1.321.76 0 1.322-.614 1.322-1.32 0-5.077-7.614-9.093-18.433-9.747h-.105V9.85c9.8.602 15.896 4.213 15.896 7.156 0 .76.614 1.322 1.32 1.322.76 0 1.322-.615 1.322-1.322 0-5.076-7.614-9.092-18.433-9.746h-.157c-.301-1.322-1.465-2.342-2.891-2.342z"
      />
    </svg>
  ),
  cap: (
    <svg viewBox="0 0 68 47">
      <path
        fill="#FFF"
        d="M34 0l34 11.12-10.584 3.271L34 21.26 0 10.794 34 0zM6.16 40.174c1.695.474 2.761 2.172 2.468 3.931-.294 1.759-1.851 3.006-3.605 2.887-1.754-.12-3.133-1.567-3.193-3.35-.06-1.782 1.22-3.321 2.962-3.561V11.325H6.16v28.85zm51.256-9.428c-.643.981-5.134 7.195-21.813 7.195s-21.17-6.214-21.81-7.195V16.353L34 22.57l23.416-6.868v15.046-.002z"
      />
    </svg>
  ),
  isLoadingCountry: (
    <svg viewBox="0 0 170 100">
      <circle fill="#ccc" stroke="none" cx="0" cy="50" r="24">
        <animate
          attributeName="opacity"
          dur="1s"
          values="0;1;0"
          repeatCount="indefinite"
          begin="0.1"
        />
      </circle>
      <circle fill="#ccc" stroke="none" cx="80" cy="50" r="24">
        <animate
          attributeName="opacity"
          dur="1s"
          values="0;1;0"
          repeatCount="indefinite"
          begin="0.2"
        />
      </circle>
      <circle fill="#ccc" stroke="none" cx="160" cy="50" r="24">
        <animate
          attributeName="opacity"
          dur="1s"
          values="0;1;0"
          repeatCount="indefinite"
          begin="0.3"
        />
      </circle>
    </svg>
  ),
  gray: (
    <svg
      viewBox="0 0 188 284"
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        strokeLinejoin: 'round',
        strokeMiterlimit: 2,
      }}
    >
      <clipPath id="a">
        <path d="M94.078 1.609v136.3a5.58 5.58 0 0 0-2.556 1.372c-4.858 4.613-9.728 10.434-11.902 16.256-3.934 9.833-3.934 19.666 0 24.582 3.172 3.964 8.903 4.732 13.067-.385a3.558 3.558 0 0 1 1.391-.968v46.489h-.085c-8.827 0-23.176-2.627-32.679-4.593a11.85 11.85 0 0 1-9.605-11.635c-.027-6.609-.027-14.986-.027-19.373a4.808 4.808 0 0 0-2.62-4.277c-.779-.401-1.553-.81-2.322-1.23a.42.42 0 0 0-.483.06l-1.138 1.054a13.557 13.557 0 0 1-20.951-3.172l-12.99-22.499a23.701 23.701 0 0 1-.551-22.685c1.597-3.06 2.812-6.795 2.812-11.038 0-9.192-10.063-25.374-10.063-32.017 0-54.612 36.005-92.241 90.617-92.241h.085Zm-4.167 4.242v129.402l-1.258 1.007c-5.297 5.029-10.535 11.426-12.919 17.774-4.58 11.481-3.961 22.947.633 28.688 2.392 2.99 5.786 4.703 9.329 4.775a11.599 11.599 0 0 0 4.215-.697v34.132c-8.501-.586-19.847-2.715-27.753-4.35a7.683 7.683 0 0 1-6.282-7.555v-.017c-.027-6.603-.027-14.973-.027-19.356v-.004a8.975 8.975 0 0 0-4.891-7.983 109.19 109.19 0 0 1-2.224-1.178 4.581 4.581 0 0 0-5.307.661l-1.138 1.053a9.394 9.394 0 0 1-14.513-2.197l-12.989-22.499a19.532 19.532 0 0 1-.455-18.696c1.87-3.59 3.274-7.972 3.274-12.944 0-5.02-2.606-11.99-5.353-18.57-2.259-5.409-4.71-10.465-4.71-13.447 0-50.753 32.545-86.173 82.368-87.999ZM78.069 109.816a4.413 4.413 0 0 0-.323-.479s-6.304-8.217-18.254-10.763c-7.642-1.629-17.701-1.009-29.908 6.038-6.928 4-8.892 9.172-8.771 15.776.095 5.182 1.766 11.477 2.768 19.048.853 6.438 5.075 10.853 10.888 13.187 7.664 3.077 18.222 2.277 25.637-2.004 12.295-7.099 17.531-14.937 19.58-21.612 3.325-10.839-1.617-19.191-1.617-19.191ZM74.46 111.9s-15.261-19.575-42.793-3.679c-10.606 6.123-5.911 15.896-3.955 30.668 1.608 12.141 19.705 14.245 30.31 8.122C85.554 131.115 74.46 111.9 74.46 111.9Z" />
      </clipPath>
      <g clipPath="url(#a)">
        <path
          style={{
            fill: '#fff',
          }}
          d="M-.791-2.558h99.035v231.98H-.791z"
        />
      </g>
      <clipPath id="b">
        <path d="M94.078 1.609c54.563.037 90.531 37.656 90.531 92.241 0 6.467-10.063 23.031-10.063 32.017 0 4.325 1.204 8.075 2.778 11.131a23.686 23.686 0 0 1-.565 22.647c-3.985 6.933-8.854 15.365-12.941 22.444a13.56 13.56 0 0 1-20.951 3.172l-.012-.011a2.573 2.573 0 0 0-2.942-.385l-.977.502a4.834 4.834 0 0 0-2.632 4.303v19.357a11.879 11.879 0 0 1-9.627 11.663c-9.478 1.932-23.766 4.549-32.599 4.565v-46.489a3.557 3.557 0 0 1 3.949.967c4.163 5.118 9.893 4.35 13.066.386 3.934-4.916 3.934-14.749 0-24.582-2.174-5.822-7.044-11.643-11.9-16.258a5.598 5.598 0 0 0-5.115-1.37V1.609ZM116.253 111.9s15.261-19.575 42.793-3.679c10.605 6.123 5.911 15.896 3.955 30.668-1.608 12.141-19.705 14.245-30.311 8.122-27.531-15.896-16.437-35.111-16.437-35.111Z" />
      </clipPath>
      <g clipPath="url(#b)">
        <path
          style={{
            fill: '#fff',
          }}
          d="M89.911-2.557h98.865v231.979H89.911z"
        />
      </g>
      <clipPath id="c">
        <path d="M94.078 238.14v42.542c19.597-.019 33.201-6.599 39.046-10.095a19.018 19.018 0 0 0 5.02-4.475c4.947-6.262 18.118-23.059 18.118-23.059.865-1.383 1.49-2.968 1.839-4.658l6.405-31.066c.579-2.812.817-5.936.896-8.644a5.56 5.56 0 0 0-6.785-5.67c-5.819 1.314-13.445 3.843-14.306 8.023l-5.877 24.337-15.507 8.133-4.186 1.184a91.324 91.324 0 0 1-24.663 3.448Z" />
      </clipPath>
      <g clipPath="url(#c)">
        <path
          style={{
            fill: '#fff',
          }}
          d="M89.911 188.465h79.734v96.383H89.911z"
        />
      </g>
      <clipPath id="d">
        <path d="M94.078 280.682V238.14a91.3 91.3 0 0 1-24.851-3.388l-4.345-1.217-16.338-8.107-4.77-23.866c-.72-4.226-8.273-6.988-14.04-8.497a5.586 5.586 0 0 0-6.985 5.474c.026 2.564.165 5.519.632 8.266l5.287 31.066c.339 1.994 1.06 3.859 2.104 5.442l18.209 22.766a19.06 19.06 0 0 0 5.148 4.482c6.036 3.461 20.122 10.121 39.864 10.121h.085Zm-29.927-43.024 3.952 1.107a95.553 95.553 0 0 0 21.808 3.46v34.189c-16.54-.814-28.366-6.409-33.678-9.449a14.875 14.875 0 0 1-3.997-3.488l-18.078-22.601c-.688-1.091-1.154-2.358-1.383-3.704l-5.286-31.066c-.43-2.529-.55-5.249-.574-7.61v-.005a1.421 1.421 0 0 1 1.774-1.393c2.597.68 5.602 1.624 8.031 2.891.799.416 1.529.863 2.128 1.361.363.302.753.532.818.911l.021.117 4.637 23.198c.734 3.673 4.22 4.018 4.22 4.018a4.179 4.179 0 0 1-1.853-.434l16.334 8.105c.445.221.826.336 1.126.393Z" />
      </clipPath>
      <g clipPath="url(#d)">
        <path
          style={{
            fill: '#fff',
          }}
          d="M18.562 188.463h79.682v96.385H18.562z"
        />
      </g>
    </svg>
  ),
  gross: (
    <svg
      viewBox="0 0 238 275"
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        strokeLinejoin: 'round',
        strokeMiterlimit: 2,
      }}
    >
      <path
        d="M185.363 88.674c9.662 0 17.616 3.455 22.036 12.091 2.214 4.327 7.836 16.647 13.464 29.236l1.349 3.023a2141.39 2141.39 0 0 1 9.543 21.706l3.161 7.33-26.328 16.669-4.081-9.319-2.023-4.617c.314 1.672.54 2.926.739 4.125.563 3.385.854 6.027.86 8.474.032 13.87-.994 33.882-3.075 60.12-.026 3.453-1.003 6.841-2.839 9.681l-.837 1.101c-2.548 2.867-6.169 4.424-9.273 4.149l-31.456-.003c-.701-.004-.884-.01-1.248-.024-3.774.302-7.395-1.255-9.943-4.122l-.837-1.101c-1.835-2.84-2.812-6.228-2.839-9.681-2.08-26.238-3.107-46.25-3.074-60.12.006-2.447.297-5.089.859-8.474.199-1.199.425-2.453.739-4.124l-3 6.849-3.104 7.086-8.734-5.53-17.594-11.139 3.161-7.33c.483-1.118 1.202-2.77 2.076-4.766a1609.99 1609.99 0 0 1 3.29-7.451l12.87 28.061 18.096-11.482 1.71 6.399c-.887 4.681-1.626 8.747-1.633 11.924-.033 13.631.993 33.545 3.076 59.744-.041 1.791.436 3.543 1.348 4.954.774.87 1.81 1.315 2.863 1.231l12.318-.001.001-63.681h8.736l-.003 63.681 12.322.001c1.054.084 2.09-.361 2.863-1.231.912-1.411 1.389-3.163 1.349-4.954 2.083-26.199 3.108-46.113 3.076-59.744-.017-6.92-3.503-18.048-4.425-30.577-.337-4.588.025-11.007 1.089-19.258.006-.98.56-1.831 1.347-2.067.786-.236 1.604.202 1.989 1.064l17.107 39.056 11.332-7.175c-3.383-7.845-19.514-44.459-24.096-53.413-2.97-5.803-8.768-7.272-14.327-7.272h-27.982c-5.559 0-11.357 1.469-14.326 7.272-1.64 3.204-4.758 9.95-8.242 17.652l-5.4-10.897c1.934-3.096 3.588-6.356 4.831-8.842l.767-1.532.335-.661c4.419-8.636 12.373-12.091 22.035-12.091h27.982Zm-35.976 36.839c.786.236 1.34 1.087 1.347 2.067 1.063 8.251 1.426 14.67 1.088 19.258-.18 2.455-.459 4.855-.791 7.18l-9.524-13.993 5.891-13.448c.384-.862 1.203-1.3 1.989-1.064Zm21.971-95.982c14.488 0 26.221 12.221 26.221 27.296 0 15.076-11.733 27.297-26.207 27.297s-26.207-12.221-26.207-27.311c.023-15.058 11.737-27.258 26.193-27.282Zm.014 9.099c-9.643.016-17.456 8.154-17.471 18.197 0 10.051 7.822 18.198 17.471 18.198 9.649 0 17.472-8.147 17.472-18.198 0-10.05-7.823-18.197-17.472-18.197Z"
        style={{
          fill: '#fff',
          fillOpacity: 0.5,
        }}
      />
      <path
        d="M98.216 74.549c11.461 0 20.743 4.009 25.838 13.908 2.666 5.178 9.323 19.656 16.132 34.778l2.189 4.872c4.613 10.287 9.107 20.443 12.283 27.764l3.098 7.141-29.339 18.466-4.113-9.334-8.841-20.065.252 105.743c.091 4.045-1.003 8.039-3.159 11.355l-.831 1.087c-2.761 3.088-6.695 4.77-10.114 4.47l-39.208-.002-.295-.001-.683-.003c-.497-.004-.75-.011-1.16-.021-4.105.327-8.039-1.355-10.8-4.443l-.831-1.087c-2.156-3.316-3.25-7.31-3.161-11.17l.254-105.928-12.954 29.399-29.338-18.466 3.097-7.141c3.176-7.321 7.67-17.477 12.283-27.764l2.189-4.872c6.81-15.122 13.466-29.6 16.132-34.778 5.095-9.899 14.378-13.908 25.838-13.908h35.242Zm0 8.963H62.974c-7.001 0-14.303 1.84-18.043 9.105-5.77 11.211-26.086 57.053-30.348 66.875l14.272 8.983 21.546-48.899c.484-1.08 1.515-1.628 2.505-1.332.99.296 1.688 1.36 1.697 2.587l-.328 137.197c-.051 2.242.55 4.435 1.698 6.202.975 1.09 2.279 1.647 3.606 1.542l16.614-.002.001-85.912h8.802l-.003 85.912 16.618.002c1.327.105 2.632-.452 3.606-1.542 1.148-1.767 1.749-3.96 1.698-6.202l-.327-137.197c.008-1.227.706-2.291 1.696-2.587.99-.296 2.021.252 2.505 1.332l21.546 48.899 14.272-8.983c-4.262-9.822-24.577-55.664-30.348-66.875-3.74-7.265-11.042-9.105-18.043-9.105ZM80.651 2.778c17.014 0 30.777 14.086 30.777 31.44s-13.763 31.44-30.763 31.44-30.763-14.086-30.763-31.454C49.929 16.87 63.67 2.805 80.651 2.778Zm.014 8.962c-12.121.02-21.942 10.072-21.961 22.478 0 12.414 9.832 22.478 21.961 22.478 12.129 0 21.962-10.064 21.962-22.478 0-12.414-9.833-22.478-21.962-22.478Z"
        style={{
          fill: '#fff',
          fillRule: 'nonzero',
        }}
      />
    </svg>
  ),
  earth: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 27" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.385 11.858s3.777-4.944 3.777-7.062a3.78 3.78 0 0 0-3.777-3.778 3.78 3.78 0 0 0-3.777 3.778c0 2.118 3.777 7.062 3.777 7.062Zm0-1.222c-.622-.872-1.62-2.339-2.318-3.709-.414-.813-.737-1.578-.737-2.131a3.056 3.056 0 0 1 3.055-3.055 3.056 3.056 0 0 1 3.055 3.055c0 .553-.323 1.318-.737 2.131-.698 1.37-1.695 2.837-2.318 3.71Zm0-7.82a1.98 1.98 0 0 0 0 3.96 1.98 1.98 0 0 0 0-3.96Zm0 .722a1.258 1.258 0 1 1 0 2.516 1.258 1.258 0 0 1 0-2.516Z"
        fill="#A2A7A9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 0C6.05 0 0 6.05 0 13.5S6.05 27 13.5 27 27 20.95 27 13.5c0-.981-.105-1.938-.304-2.86a.362.362 0 0 0-.707.153 12.806 12.806 0 0 1 .24 3.819l-.004.002c-1.638.956-3.698 1.723-6.035 2.23.157-1.117.24-2.294.24-3.508 0-.893-.045-1.765-.13-2.608.593-.139 1.168-.296 1.72-.47a.362.362 0 0 0-.217-.689c-.51.16-1.04.307-1.588.437-.316-2.378-.96-4.496-1.827-6.158.493-.147.957-.315 1.388-.502a.362.362 0 0 0-.287-.663c-.452.196-.942.37-1.464.519a10.34 10.34 0 0 0-.35-.541c-.464-.673-.974-1.232-1.518-1.661 1.302.276 2.532.75 3.656 1.39a.362.362 0 0 0 .358-.627A13.433 13.433 0 0 0 13.5 0ZM5.046 23.077a12.733 12.733 0 0 0 6.466 3.046c-.723-.409-1.399-1.038-2.003-1.854-1.644-.255-3.153-.664-4.463-1.192Zm16.908 0c-1.31.528-2.82.937-4.463 1.192-.604.816-1.28 1.445-2.003 1.854a12.734 12.734 0 0 0 6.466-3.046ZM10.552 24.41c.873.973 1.873 1.54 2.948 1.54s2.075-.567 2.948-1.54c-.95.106-1.936.162-2.948.162a26.5 26.5 0 0 1-2.948-.162Zm-2.864-6.655c.44 2.357 1.221 4.385 2.23 5.846 1.139.162 2.34.249 3.582.249s2.443-.087 3.58-.248h.001c1.01-1.462 1.791-3.49 2.23-5.847a32.926 32.926 0 0 1-5.811.505c-2.04 0-3.996-.178-5.812-.505Zm18.433-2.253c-1.678.902-3.738 1.627-6.05 2.107-.4 2.293-1.111 4.304-2.03 5.836 2.09-.387 3.929-1.035 5.354-1.866l.004-.003a12.722 12.722 0 0 0 2.722-6.074ZM.88 15.5A12.722 12.722 0 0 0 3.6 21.575l.003.003c1.426.831 3.264 1.479 5.355 1.866-.919-1.532-1.63-3.543-2.03-5.836-2.312-.48-4.372-1.205-6.05-2.107Zm6.532-4.617a25.136 25.136 0 0 0-.119 2.452c0 1.272.094 2.501.269 3.661 1.846.35 3.848.54 5.939.54 2.09 0 4.093-.19 5.939-.54a25.13 25.13 0 0 0 .15-6.112c-1.878.386-3.934.6-6.089.6-2.155 0-4.211-.215-6.09-.6ZM1.599 8.843a12.733 12.733 0 0 0-.824 5.771c1.638.956 3.698 1.723 6.035 2.23a25.722 25.722 0 0 1-.109-6.117c-1.943-.455-3.675-1.1-5.102-1.884Zm7.728-4.802c-.881 1.629-1.528 3.742-1.835 6.123 1.85.385 3.88.598 6.008.598s4.157-.213 6.007-.598c-.307-2.381-.953-4.494-1.834-6.123-1.261.308-2.677.48-4.173.48s-2.912-.173-4.173-.48Zm-2.98-1.127a12.843 12.843 0 0 0-4.464 5.26c1.369.763 3.033 1.388 4.902 1.833.315-2.379.96-4.497 1.827-6.159a11.276 11.276 0 0 1-2.265-.934ZM13.5.723c-1.345 0-2.573.888-3.582 2.348-.07.104-.141.21-.21.319 1.155.263 2.44.409 3.792.409 1.352 0 2.636-.146 3.792-.41-.07-.108-.14-.214-.21-.318C16.071 1.611 14.844.723 13.5.723ZM10.843 1a12.7 12.7 0 0 0-3.791 1.47c.57.284 1.217.531 1.922.733.114-.188.23-.369.35-.542.464-.673.975-1.232 1.52-1.661Z"
        fill="#A2A7A9"
      />
    </svg>
  ),
};

type IconProps = {
  className?: string;
  baseline?: boolean;
  rotate?: number;
  size?: number;
  smSize?: number;
  mSize?: number;
  lgSize?: number;
  smSizeWidth?: number;
  smSizeHeight?: number;
  width?: string | number;
  height?: string | number;
  color?: string;
  name?: keyof typeof icons;
  ml?: number;
  mr?: number;
  hoverable?: boolean;
  onClick?: () => void;
};

class Icon extends PureComponent<IconProps> {
  render() {
    const { name, className, onClick } = this.props;

    return (
      <span role="img" className={className} onClick={onClick}>
        {icons[name]}
      </span>
    );
  }
}

const styledIcon = styled(Icon)`
  display: inline-flex;
  flex-direction: column;
  align-self: center;
  position: relative;
  font-size: 1em;
  color: ${props => props.theme.colors[props.color]};
  fill: currentColor;

  ${props => getStyle(props.size, 'width', 'em')}
  ${props => getStyle(props.size, 'height', 'em')}

  ${props =>
    props.height &&
    css`
      height: ${typeof props.height === 'string'
        ? props.height
        : `${props.height}em`};
    `};

  ${props =>
    props.width &&
    css`
      width: ${typeof props.width === 'string'
        ? props.width
        : `${props.width}em`};
    `};

  ${props =>
    props.hoverable &&
    `
    cursor: pointer;
  `}

  ${props => getStyle(props.ml, 'margin-left', 'em')}
  ${props => getStyle(props.mr, 'margin-right', 'em')}
  
  ${breakpoint.down('ltm')`
    ${props => getStyle(props.smSize, 'width', 'em')}
    ${props => getStyle(props.smSize, 'height', 'em')}

    ${props => getStyle(props.smSizeWidth, 'width', 'em')}
    ${props => getStyle(props.smSizeHeight, 'height', 'em')}
    
    ${props => getStyle(props.smMl, 'margin-left', 'em')}
  `}
  
  ${breakpoint.only('m', 'ltLg')`
    ${props => getStyle(props.mSize, 'width', 'em')}
    ${props => getStyle(props.mSize, 'height', 'em')}
    
    ${props => getStyle(props.mMl, 'margin-left', 'em')}
  `}

  ${breakpoint.up('lg')`
    ${props => getStyle(props.lgSize, 'width', 'em')}
    ${props => getStyle(props.lgSize, 'height', 'em')}
    
    ${props => getStyle(props.lgMl, 'margin-left', 'em')}
  `} 
 
  > svg {
    fill: currentColor;
    transition: transform 0.2s;

    height: inherit;
    width: inherit;

    ${props =>
      typeof props.rotate !== 'undefined' &&
      `
      transform: rotate(${props.rotate}deg);
    `}

    ${props =>
      props.baseline &&
      `
      bottom: -0.125em;
      position: absolute;
    `}
    
    ${breakpoint.down('ltm')`
      ${props => getStyle(props.smSize, 'width', 'em')}
      ${props => getStyle(props.smSize, 'height', 'em')}
    `}

    ${breakpoint.only('m', 'ltLg')`
      ${props => getStyle(props.mSize, 'width', 'em')}
      ${props => getStyle(props.mSize, 'height', 'em')}
    `}

    ${breakpoint.up('lg')`
      ${props => getStyle(props.lgSize, 'width', 'em')}
      ${props => getStyle(props.lgSize, 'height', 'em')}
    `}
  }
`;

styledIcon.defaultProps = {
  size: 1,
  hoverable: false,
};

export default styledIcon;
